import { Uuid } from "../../domain/model/uuid/uuid.type";
import { WeighingType } from "../../domain/model/weighing-type";
import { FeedViewModel } from "../shared/feed.viewmodel";
import { GroupViewModel } from "../shared/group.viewmodel";
import { PenViewModel } from "../shared/pen.viewmodel";
import { UpdateInfoViewModel } from "../shared/update.viewmodel";

export class AnimalWeighingViewModel {
  constructor(
    readonly id: Uuid,
    readonly batchWeighingId: Uuid,
    readonly type: WeighingType,
    readonly pen: PenViewModel,
    readonly group: GroupViewModel,
    readonly feed: FeedViewModel,
    readonly update: UpdateInfoViewModel,
    readonly inputNumber: number,
    readonly inputWeight: number
  ) {  }

  toString(): string {
    return `Id: ${this.id}, Type: ${this.type}, Pen: ${this.pen}, Group: ${this.group}, Feed: ${this.feed}, InputNumber: ${this.inputNumber}, InputWeight: ${this.inputWeight}`;
  }
}
